/**
 * refuseHeldEnter — an onKeyDown handler: one press of Enter, however long it
 * is held, activates a control once.
 *
 * Enter clicks a button on every keydown, auto-repeats included. Two cases
 * need the repeats refused:
 *
 *   - A press moves focus onto a button (closing a panel hands focus back to
 *     the control that opens it). The repeats of that same press land on the
 *     new button and click it: the panel the student just closed opens again
 *     before they have let go of the key.
 *   - A control keeps focus while its own request runs (aria-disabled, or
 *     readOnly for a text field; components/ui/Button applies this guard to
 *     every Button). The repeats keep arriving, and the first one after the
 *     request settles would send it again. A natively disabled control never
 *     met them, because it lost focus on the first press.
 *
 * Cancelling the repeated keydown cancels its click, or the form submit it
 * would have become in a text input. A fresh press is untouched, and only
 * Enter is filtered: Space clicks on keyup, so it has no repeat to guard.
 * Don't put it on a <textarea>, where a held Enter types new lines.
 *
 *   <button onKeyDown={refuseHeldEnter} onClick={...}>
 */
export default function refuseHeldEnter(event) {
  if (event.key === 'Enter' && event.repeat) event.preventDefault();
}
